import script from "./about-us.vue?vue&type=script&setup=true&lang=js"
export * from "./about-us.vue?vue&type=script&setup=true&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=c422f1d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c422f1d4"]])

export default __exports__